import { DrugTripletInteractionResult } from "domain/entities/drug-triplet-interaction";
import { DrugTripletInteractionRepository } from "domain/repositories";

export default class GetAllUseCase {
    private drugTripletInteractionRepository: DrugTripletInteractionRepository;
    
    public constructor(drugTripletInteractionRepository: DrugTripletInteractionRepository) {
        this.drugTripletInteractionRepository = drugTripletInteractionRepository
    }

    public async getAllDrugTripletInteractions(token: Promise<[string | null, string | null]>): Promise<[DrugTripletInteractionResult[], null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.drugTripletInteractionRepository.getAllDrugTripletInteraction(t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}